export const DASHBOARD_TABS = {
    NOTIFICATION: "v-pills-notification-tab",
    ORDER: "v-pills-order-tab",
    MY_VIDEO: "v-pills-my-video-tab",
    UPDATE: "v-pills-update-tab",
    TESTIMONIAL: "v-pills-testimonial-tab",
    REQUEST_A_NURSE: "v-pills-request-a-nurse-tab",
    CONSULTATIONS: "v-pills-consultations-tab"
} as const;

export type DashboardTabId = typeof DASHBOARD_TABS[keyof typeof DASHBOARD_TABS];

export const DASHBOARD_TAB_SLUGS = {
  notifications: DASHBOARD_TABS.NOTIFICATION,
  orderHistory: DASHBOARD_TABS.ORDER,
  myVideos: DASHBOARD_TABS.MY_VIDEO,
  updateProfile: DASHBOARD_TABS.UPDATE,
  testimonials: DASHBOARD_TABS.TESTIMONIAL,
  requestANurse: DASHBOARD_TABS.REQUEST_A_NURSE,
  consultations: DASHBOARD_TABS.CONSULTATIONS
} as const;

export type DashboardTabSlug = keyof typeof DASHBOARD_TAB_SLUGS;

export const DASHBOARD_TAB_ID_TO_SLUG: Record<DashboardTabId, DashboardTabSlug> = Object.entries(DASHBOARD_TAB_SLUGS)
  .reduce((acc, [slug, id]) => {
    acc[id] = slug as DashboardTabSlug;
    return acc;
  }, {} as Record<DashboardTabId, DashboardTabSlug>);
